<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>基地全景</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<div id="videofull" style="background-color: #f0f0f0;">
			<el-row class="top">
				<el-col :span="12">
					<div>
						<el-radio-group v-model="fg" @change="change()" :size="$store.state.width<$store.state.minwidth?'mini':''">
							<el-radio-button label="2×2"></el-radio-button>
							<el-radio-button v-if="$store.state.video.ysylist.page.total>4" label="3×3"></el-radio-button>
							<el-radio-button v-if="$store.state.video.ysylist.page.total>9" label="4×4"></el-radio-button>
						</el-radio-group>
						<el-button style="margin-left: 10px;" @click="full()">{{isFull?'退出全屏':'全屏模式'}}</el-button>
					</div>
				</el-col>
				<el-col :span="12" class="top1">
					<span>摄像头总数：</span><span style="color: #1991FA;">{{$store.state.video.ysylist.page.total}}</span><span>个</span>
				</el-col>
				<el-col :span="1"></el-col>
			</el-row>
			<el-row class="video-top" v-if="reFresh">
				<el-col :span="24">
					<el-col v-for="(item,index) in $store.state.video.ysylist.list" :key="index" :md="24/Number(fg.split('×')[0])">
						<div class="gz">
							<div :id="'father'+index" class="card" :style="'height:' + height[fg] + 'px;'">
								<video :id="index" :src="$store.state.width<$store.state.minwidth?item.rtmp:item.liveAddress" class="ship"
								 autoplay></video>
							</div>
						</div>
					</el-col>
					<!-- <div v-for="item in emptys" :key="item">
						<el-col :span="24/Number(fg.split('×')[0])">
							<div class="gz">
								<div class="card" :style="'height:'+height[fg]+'px;'">
									<div class="none" :style="'margin-top:' + (height[fg]/2-20) + 'px;'">暂无视频！</div>
								</div>
							</div>
						</el-col>
					</div> -->
				</el-col>
			</el-row>
			<el-row class="video-top">
				<el-col :span="24">
					<el-pagination :current-page.sync="$store.state.production.page" background layout="prev, pager, next" :page-size="$store.state.production.pagesize"
					 :total="$store.state.video.ysylist.page.total" @current-change="handleCurrentChange" align="center"></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				myload: true,
				fg: '3×3',
				height: {
					'4×4': 203,
					'3×3': 240,
					'2×2': 360
				},
				reFresh: true,
				isFull: false
			};
		},
		methods: {
			handleCurrentChange(val) {
				this.$store.commit('page', val);
				this.load();
			},
			change() {
				this.$store.commit('page', 1);
				this.load();
			},
			addVideo(id) {
				let video = document.createElement('video');
				video.src = this.$store.state.width > this.$store.state.minwidth ? this.$store.state.video.ysylist.list[id].rtmp :
					this.$store.state.video.ysylist.list[id].liveAddress;
				video.controls = true;
				video.id = id.toString();
				video.autoplay = true;
				video.style.width = "98%";
				video.style.height = "100%";
				let oldvideo = document.getElementById(id.toString());
				let videodiv = document.getElementById("father" + id);
				videodiv.removeChild(oldvideo);
				videodiv.appendChild(video);
				new EZUIPlayer(id.toString());
			},
			load() {
				this.$store.commit('pagesize', Number(this.fg.split('×')[0]) * Number(this.fg.split('×')[0]));
				let value = {
					vcr_id: this.$route.query.id
				}
				this.$store.commit('mainload', true);
				this.getysylist(value)
					.then((response) => {
						if (response.data.code == 1) {
							if (this.$store.state.video.ysylist.page.total <= 4) {
								this.fg = "2×2";
							}
							this.reFresh = false;
							this.$nextTick(() => {
								this.reFresh = true
							});
							this.$store.commit('mainload', false);
						}
					});
			},
			full() {
				if (this.isFull) {
					this.exitScreen();
				} else {
					this.fullScreen();
				}
			},
			fullScreen() {
				let el = document.getElementById("videofull");
				let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;
				if (rfs) {
					rfs.call(el);
				} else if (typeof window.ActiveXObject !== "undefined") {
					let wscript = new window.ActiveXObject("WScript.Shell");
					if (wscript != null) {
						wscript.SendKeys("{F11}");
					}
				}
				this.isFull = true;
			},
			exitScreen() {
				let el = document;
				let cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen;
				if (cfs) {
					cfs.call(el);
				} else if (typeof window.ActiveXObject !== "undefined") {
					//for IE，这里和fullScreen相同，模拟按下F11键退出全屏
					let wscript = new window.ActiveXObject("WScript.Shell");
					if (wscript != null) {
						wscript.SendKeys("{F11}");
					}
				}
				this.isFull = false;
			}
		},
		mounted: function() {
			this.$store.commit('page', 1);
			this.load();
		},
		updated() {
			for (var i = 0; i < this.$store.state.video.ysylist.list.length; i++) {
				this.addVideo(i);
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.load();
				}
			}
		}
	}
</script>

<style scoped>
	.box {
		text-align: left;
		margin: 50px;
	}

	.card {
		min-height: 203px;
		width: 95%;
		margin: 5px auto;
		background-color: #000;
		text-align: center;
		padding: 5px;
	}

	.ship {
		width: 100%;
		height: 100%;
	}

	.gz {
		padding: 0px;
	}

	.none {
		color: #FFFFFF;
		font-size: 40px;
		font-family: 'STKaiti';
	}

	.title {
		text-align: center;
		margin-top: 0px;
	}

	.top {
		margin-top: 10px;
		padding: 0 5px;
	}

	.top1 {
		margin-top: 5px;
		text-align: right;
		font-size: 20px
	}

	.video-top {
		margin-top: 0px;
	}

	.bread {
		height: 14px;
		padding: 8px 0;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.gz {
			padding: 0px;
		}

		.top1 {
			margin: 0;
			font-size: 16px;
			line-height: 28px;
		}
	}
</style>
